<template>
  <div id="materialAccessories">
    <div class="material" :class="{'minBox':bodyWidth<=1680}">
      <div class="material-tit">员工基本资料</div>
      <div class="material-box">
        <div class="material-info" @click="toDetails('身份证原件照片')">
          <div class="material-cover">
            <img src="@/assets/image/bgIDcard.png" alt />
          </div>
          <div class="material-name">身份证原件照片</div>
        </div>
        <div class="material-info" @click="toDetails('学历证明')">
          <div class="material-cover">
            <img src="@/assets/image/bgEducationCertificate.png" alt />
          </div>
          <div class="material-name">学历证明</div>
        </div>
        <div class="material-info" @click="toDetails('个人证件照')">
          <div class="material-cover">
            <img src="@/assets/image/bgPersonalCertificate.png" alt />
          </div>
          <div class="material-name">个人证件照</div>
        </div>
        <div class="material-info" @click="toDetails('身份证复印件')">
          <div class="material-cover">
            <img src="@/assets/image/bgCopyID.png" alt />
          </div>
          <div class="material-name">身份证复印件</div>
        </div>
        <div class="material-info" @click="toDetails('工资银行卡')" v-if="key=='员工基本资料'||isShowWidth">
          <div class="material-cover">
            <img src="@/assets/image/bgWageBankCard.png" alt />
          </div>
          <div class="material-name">工资银行卡</div>
        </div>
        <div class="material-info" @click="toDetails('社保卡')" v-if="key=='员工基本资料'">
          <div class="material-cover">
            <img src="@/assets/image/bgSocialSecurity.png" alt />
          </div>
          <div class="material-name">社保卡</div>
        </div>
        <div class="material-info" @click="toDetails('公积金卡')" v-if="key=='员工基本资料'">
          <div class="material-cover">
            <img src="@/assets/image/bgProvidentFund.png" alt />
          </div>
          <div class="material-name">公积金卡</div>
        </div>
        <div class="material-info" @click="toDetails('职业资格证书')" v-if="key=='员工基本资料'">
          <div class="material-cover">
            <img src="@/assets/image/bgProfessional QualificationCertificate.png" alt />
          </div>
          <div class="material-name">职业资格证书</div>
        </div>
        <div class="material-info" @click="toDetails('获奖证书')" v-if="key=='员工基本资料'">
          <div class="material-cover">
            <img src="@/assets/image/bgAwardCertificate.png" alt />
          </div>
          <div class="material-name">获奖证书</div>
        </div>
        <div
          class="material-info"
          v-for="(item,index) in material.basicMaterialTypeInfo "
          @click="toDetails(item.option)"
          :key="index"
          v-show="key=='员工基本资料'"
        >
          <div class="material-text">{{item.option}}</div>
          <div class="material-name">{{item.option}}</div>
        </div>
        <div class="material-btn on" @click="showMore('员工基本资料')" v-if="key!='员工基本资料'">
          更多资料
          <img src="@/assets/image/icon-open.png" alt />
        </div>
        <div class="material-btn off" @click="key='-1'" v-if="key=='员工基本资料'">
          <img src="@/assets/image/icon-off.png" alt />
          收起
        </div>
      </div>
    </div>
    <div class="material" :class="{'minBox':bodyWidth<=1680}">
      <div class="material-tit">员工档案资料</div>
      <div class="material-box">
        <div class="material-info" @click="toDetails('入职简历')">
          <div class="material-cover">
            <img src="@/assets/image/bgEntryResume.png" alt />
          </div>
          <div class="material-name">入职简历</div>
        </div>
        <div class="material-info" @click="toDetails('劳动合同')">
          <div class="material-cover">
            <img src="@/assets/image/bgLaborContract.png" alt />
          </div>
          <div class="material-name">劳动合同</div>
        </div>

        <div class="material-info" @click="toDetails('入职登记表')">
          <div class="material-cover">
            <img src="@/assets/image/bgEntryregistration.png" alt />
          </div>
          <div class="material-name">入职登记表</div>
        </div>
        <div class="material-info" @click="toDetails('入职健康体检表')">
          <div class="material-cover">
            <img src="@/assets/image/bgEntryPhysicalExamination.png" alt />
          </div>
          <div class="material-name">入职健康体检表</div>
        </div>
        <div class="material-info" @click="toDetails('上家公司离职证明')" v-if="key=='员工档案资料'||isShowWidth">
          <div class="material-cover">
            <img src="@/assets/image/bgResignationApproval.png" alt />
          </div>
          <div class="material-name">上家公司离职证明</div>
        </div>
        <div class="material-info" @click="toDetails('工作申请表')" v-if="key=='员工档案资料'">
          <div class="material-cover">
            <img src="@/assets/image/bgWorkApplication.png" alt />
          </div>
          <div class="material-name">工作申请表</div>
        </div>
        <div class="material-info" @click="toDetails('调薪通知单')" v-if="key=='员工档案资料'">
          <div class="material-cover">
            <img src="@/assets/image/bgNoticeSalaryAdjustment.png" alt />
          </div>
          <div class="material-name">调薪通知单</div>
        </div>
        <div class="material-info" @click="toDetails('转正申请表')" v-if="key=='员工档案资料'">
          <div class="material-cover">
            <img src="@/assets/image/bgEmploymentConfirmationApplication.png" alt />
          </div>
          <div class="material-name">转正申请表</div>
        </div>
        <div class="material-info" @click="toDetails('社会保险转移单')" v-if="key=='员工档案资料'">
          <div class="material-cover">
            <img src="@/assets/image/bgSocialInsuranceTransferPolicy.png" alt />
          </div>
          <div class="material-name">社会保险转移单</div>
        </div>
        <div class="material-info" @click="toDetails('人事异动申请表')" v-if="key=='员工档案资料'">
          <div class="material-cover">
            <img src="@/assets/image/bgPersonnelChangeApplication .png" alt />
          </div>
          <div class="material-name">人事异动申请表</div>
        </div>
        <div class="material-info" @click="toDetails('绩效考核结果报告')" v-if="key=='员工档案资料'">
          <div class="material-cover">
            <img src="@/assets/image/bgPerformanceAppraisalResult.png" alt />
          </div>
          <div class="material-name">绩效考核结果报告</div>
        </div>
        <div class="material-info" @click="toDetails('其他')" v-if="key=='员工档案资料'">
          <div class="material-cover">
            <img src="@/assets/image/bgOther.png" alt />
          </div>
          <div class="material-name">其他</div>
        </div>
        <div
          class="material-info"
          v-for="(item,index) in material.normalMaterialTypeInfo "
          @click="toDetails(item.option)"
          :key="index"
          v-show="key=='员工档案资料'"
        >
          <div class="material-text">{{item.option}}</div>
          <div class="material-name">{{item.option}}</div>
        </div>
        <div class="material-btn on" @click="showMore('员工档案资料')" v-if="key!='员工档案资料'">
          更多资料
          <img src="@/assets/image/icon-open.png" alt />
        </div>
        <div class="material-btn off" @click="key='-1'" v-if="key=='员工档案资料'">
          <img src="@/assets/image/icon-off.png" alt />
          收起
        </div>
      </div>
    </div>
    <div class="material" :class="{'minBox':bodyWidth<=1680}">
      <div class="material-tit">员工离职资料</div>
      <div class="material-box">
        <div class="material-info" @click="toDetails('离职申请表')">
          <div class="material-cover">
            <img src="@/assets/image/bgResignationApplication.png" alt />
          </div>
          <div class="material-name">离职申请表</div>
        </div>
        <div class="material-info" @click="toDetails('离职审批')">
          <div class="material-cover">
            <img src="@/assets/image/bgResignationApproval.png" alt />
          </div>
          <div class="material-name">离职审批</div>
        </div>
        <div class="material-info" @click="toDetails('离职证明')">
          <div class="material-cover">
            <img src="@/assets/image/bgLeavingCertificate.png" alt />
          </div>
          <div class="material-name">离职证明</div>
        </div>
        <div class="material-info" @click="toDetails('工作交接表')">
          <div class="material-cover">
            <img src="@/assets/image/bgWorkHandover.png" alt />
          </div>
          <div class="material-name">工作交接表</div>
        </div>

        <div
          class="material-info"
          v-for="(item,index) in material.firedMaterialTypeInfo "
          @click="toDetails(item.option)"
          :key="index"
          v-show="key=='员工离职资料'"
        >
          <div class="material-text">{{item.option}}</div>
          <div class="material-name">{{item.option}}</div>
        </div>
        <div class="material-btn on" @click="showMore('员工离职资料')" v-if="key!='员工离职资料'">
          更多资料
          <img src="@/assets/image/icon-open.png" alt />
        </div>
        <div class="material-btn off" @click="key='-1'" v-if="key=='员工离职资料'">
          <img src="@/assets/image/icon-off.png" alt />
          收起
        </div>
      </div>
    </div>
    <!-- 循环生成，但图标不显示 -->
    <!-- <div class="material" v-for="(material,materialIndex) in materials" :key="materialIndex">
      <div class="material-tit">{{material.materialType}}</div>
      
    </div>-->
  </div>
</template>

<script>
import { getUserSettings } from "@/http/api/system";
export default {
  data() {
    return {
      key: "",
      id: this.$route.params.id,
      bodyWidth: 1920,
      isShowWidth: false,
      material: {
        firedMaterialTypeInfo: [],
        normalMaterialTypeInfo: [],
        basicMaterialTypeInfo: [],
      },
    };
  },
  mounted() {
    this.bodyWidth = document.body.clientWidth;
    // //console.log(this.bodyWidth,66666);
    if (this.bodyWidth > 1680) {
      this.isShowWidth = true;
    } else {
      this.isShowWidth = false;
    }
    this.getSettingsInfo();
  },
  methods: {
    showMore(val) {
      this.key = val;
    },
    toDetails(val) {
      this.$router.push(`/channel/employe/material-details/${this.id}?type=${val}`);
    },
    // 获取基础字段
    getSettingsInfo() {
      getUserSettings().then((res) => {
        let basicMaterialTypeInfo = [],
          normalMaterialTypeInfo = [],
          firedMaterialTypeInfo = [];
        res.result.map((item) => {
          if (item.name == "Deer.User.BasicMaterialType") {
            // //console.log(item,'获取的基础字段');
            basicMaterialTypeInfo = item.value;
          } else if (item.name == "Deer.User.NormalMaterialType") {
            normalMaterialTypeInfo = item.value;
          } else if (item.name == "Deer.User.FiredMaterialType") {
            firedMaterialTypeInfo = item.value;
          }
        });

        basicMaterialTypeInfo.forEach((item) => {
          if (!item.isDefault) {
            this.material.basicMaterialTypeInfo.push(item);
          }
        });
        normalMaterialTypeInfo.forEach((item) => {
          if (!item.isDefault) {
            this.material.normalMaterialTypeInfo.push(item);
          }
        });
        firedMaterialTypeInfo.forEach((item) => {
          if (!item.isDefault) {
            this.material.firedMaterialTypeInfo.push(item);
          }
        });
        //console.log(this.material, "获取的基础字段");
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#materialAccessories {
  min-height: calc(100vh - 220px);

  .material {
    position: relative;
    margin-bottom: 26px;
    padding: 25px 20px;
    min-height: calc(100vh - 215px);
    border-radius: $--border-radius-base;
    background-color: #fff;
    // box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);

    .material-tit {
      margin-bottom: 24px;
      font-size: 14px;
      font-weight: bold;
      color: #000;
    }

    .material-box {
      @include flex(row, center);
      flex-wrap: wrap;
      .material-info {
        margin-right: 30px;
        margin-bottom: 24px;
        border: 1px solid #ddd;
        width: 225px !important;
      height: 165px !important;
        cursor: pointer;
        .material-cover {
          margin: 9px;
          border: 1px dashed #ddd;
          width: 205px;
          height: 115px;
          @include flex(column, center);
          justify-content: center;
          img {
            height: 30px;
          }
        }
        .material-text {
          margin: 9px;
          border: 1px dashed #ddd;
          width: 170px;
          height: 100px;
          @include flex(column, center);
          justify-content: center;
        }
        .material-name {
          margin: 0 9px 9px;
          color: #444;
        }
      }
    }
    .material-btn {
      @include flex(row, center);
      position: absolute;
      right: 20px;
      top: 68px;
      justify-content: center;
      margin-bottom: 24px;
      padding: 0 8px;
      border: 1px solid #ddd;
      writing-mode: tb-rl;
      height: 144px;
      line-height: 12px;
      font-size: 12px;
      cursor: pointer;
      letter-spacing: 7px;
      color: #444444;
      img {
        margin: 7px 0;
        width: 12px;
      }
    }
  }
  .material:last-child {
    margin-bottom: 0;
  }
  .minBox {
    .material-info {
      width: 225px !important;
      height: 165px !important;
      .material-cover,
      .material-text {
        width: 205px !important;
        height: 122px !important;
      }
    }
    .material-btn {
      height: 165px;
    }
  }
}
</style>
